import axios from 'axios'
import store from '@/store/'

axios.defaults.baseURL = process.env.VUE_APP_URL

// Request interceptor
axios.interceptors.request.use(request => {
	const token = store.state.token

	if (token) {
		request.headers.common['Authorization'] = `Bearer ${token}`
	}

	return request
})

axios.interceptors.response.use(response => response, error => {
	return Promise.reject(error)
})
